export enum CarClass {
  comment = "Comment",
  minor = "Minor",
  major = "Major",
  critical = "Critical",
}
